import { getEnvs } from "./env";
import { getInitialLocale } from "./translation";
import { getWhiteLabel } from "./white-label";

declare global {
  interface Window {
    zESettings?: Record<string, unknown>;
    zE?: (...args: unknown[]) => void;
  }
}

const REGIONAL_ZENDESK_LOCALES = new Set(["en-us", "pt-br", "zh-cn", "zh-tw"]);

// Zendesk takes base codes (`ru`, `ja`) except for these regional variants.
export const toZendeskLocale = (locale: string) => {
  const normalized = locale.toLowerCase().replace("_", "-");
  return REGIONAL_ZENDESK_LOCALES.has(normalized)
    ? normalized
    : normalized.split("-")[0];
};

export const setZendesk = () => {
  const { zendeskEnabled, helpChatThemeColor, helpButtonColor, partnerRef } =
    getWhiteLabel();
  const { DEPLOY_ENV, MOZIO_PUBLIC_ZENDESK_KEY } = getEnvs();

  if (DEPLOY_ENV === "development" || DEPLOY_ENV === "preview") {
    return;
  }

  if (!zendeskEnabled || !MOZIO_PUBLIC_ZENDESK_KEY) {
    return;
  }

  const zendeskPartnerTag = `partner-${partnerRef === "mozio_web" ? "mozio" : partnerRef}`;

  const script = document.createElement("script");
  script.id = "ze-snippet";
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${MOZIO_PUBLIC_ZENDESK_KEY}`;
  script.async = true;
  script.addEventListener("load", () => {
    window.zE?.(
      "messenger:set",
      "locale",
      toZendeskLocale(getInitialLocale(true)),
    );
    window.zESettings = {
      webWidget: {
        chat: {
          tags: ["website", zendeskPartnerTag],
        },
        color: {
          theme: helpChatThemeColor,
          button: helpButtonColor,
        },
        helpCenter: {
          originalArticleButton: false,
        },
      },
    };
  });

  document.head.append(script);
};
